'use client';

import { useState } from 'react';
import { useRouter } from 'next/navigation';
import Link from 'next/link';
import { ArrowRight, Hash } from 'lucide-react';
import { ThemeSwitch } from '@/components/ThemeSwitch';

export default function LandingPage() {
  const router = useRouter();
  const [sessionCode, setSessionCode] = useState('');

  const handleStartExercise = (e: React.FormEvent) => {
    e.preventDefault();
    if (sessionCode.trim()) {
      router.push(`/exercise/${sessionCode.trim()}`);
    }
  };

  return (
    <div className="min-h-screen flex flex-col items-center justify-center p-4 text-center relative">
        <div className="absolute top-4 right-4">
            <ThemeSwitch />
        </div>
      <main className="w-full max-w-2xl">
        <h1 className="text-5xl md:text-6xl font-bold text-gray-800 dark:text-gray-100">
          Osobnostní test Enneagram
        </h1>
        <p className="text-lg md:text-xl text-gray-600 dark:text-gray-400 mt-4 mb-12">
          Objevte svůj typ osobnosti pomocí podrobného testu. Pro spuštění zadejte kód, který jste obdrželi od správce.
        </p>

        <div className="bg-white/60 dark:bg-gray-800/60 backdrop-blur-sm border border-gray-200 dark:border-gray-700 rounded-xl shadow-lg p-8">
          <form onSubmit={handleStartExercise} className="flex flex-col sm:flex-row gap-4">
            <div className="relative flex-grow">
              <Hash
                className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400"
                size={20}
              />
              <input
                type="text"
                value={sessionCode}
                onChange={(e) => setSessionCode(e.target.value)}
                placeholder="Zadejte kód testu"
                required
                className="w-full pl-10 pr-3 py-3 border border-gray-300 dark:border-gray-600 rounded-lg focus:ring-blue-500 focus:border-blue-500 text-lg bg-white dark:bg-gray-700 text-gray-900 dark:text-gray-100 placeholder-gray-500 dark:placeholder-gray-400"
                aria-label="Kód testu"
              />
            </div>
            <button
              type="submit"
              disabled={!sessionCode.trim()}
              className="bg-blue-600 text-white font-bold py-3 px-6 rounded-lg hover:bg-blue-700 dark:bg-blue-500 dark:hover:bg-blue-600 transition-colors flex items-center justify-center gap-2 text-lg disabled:bg-gray-400 disabled:cursor-not-allowed"
            >
              Spustit test <ArrowRight size={20} />
            </button>
          </form>
        </div>
      </main>

      <footer className="absolute bottom-6 text-gray-500 dark:text-gray-400">
        <Link href="/login" className="hover:text-blue-600 dark:hover:text-blue-400 hover:underline transition-colors">
          Přihlášení pro správce
        </Link>
      </footer>
    </div>
  );
}
